<template>
  <v-navigation-drawer
    :clipped="$vuetify.breakpoint.mdAndUp"
    :mini-variant="navigationDrawerMini"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :touchless="$vuetify.breakpoint.mdAndUp"
    app
    fixed
    v-if="requiresComponent"
    v-model="navigationDrawer"
  >
    <v-list>
      <v-list-tile
        :key="i"
        :to="route.path"
        v-for="(route, i) in routes"
        v-show="route.navigationDrawer"
      >
        <v-list-tile-action>
          <v-icon v-text="route.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="route.name"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import '@/scss/navigationDrawer.scss';

export default {
  name: 'NavigationDrawer',
  computed: {
    navigationDrawer: {
      set(value) {
        this.$store.commit('NAVIGATION_DRAWER', value);
      },
      get() {
        return this.$store.getters.navigationDrawer;
      },
    },
    navigationDrawerMini: {
      set(value) {
        this.$store.commit('NAVIGATION_DRAWER_MINI', value);
      },
      get() {
        // on screen resize this getter is called.
        // because of this fact we can set the value of mini on the vuetify breakpoins
        // yes it could be considered hackey and functionality in the wrong place
        if (this.$vuetify.breakpoint.mdAndUp) {
          return this.$store.getters.navigationDrawerMini;
        }
        this.$store.commit('NAVIGATION_DRAWER_MINI', true);
        return false;
      },
    },

    routes() {
      return this.$router.options.routes;
    },
    requiresComponent() {
      if (this.$route.name === 'Login') {
        return false;
      }
      return true;
    },
  },
};
</script>
